import { Printer } from "lucide-react";

import { Button, type ButtonProps } from "@buildpy/ui/button";

interface Props {
  label?: string;
  variant?: "primary" | "outline" | "secondary";
  size?: ButtonProps["size"];
  className?: string;
}

/** 인쇄 버튼 하나. 이것 때문에 문서 전체가 클라이언트 컴포넌트가 되지 않게 따로 뗀다. */
const PrintButton = ({ label = "인쇄", variant = "primary", size = "sm", className }: Props) => {
  return (
    <Button className={className} size={size} variant={variant} onClick={() => window.print()}>
      <Printer />
      {label}
    </Button>
  );
};

export default PrintButton;
